import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import styled from '@mui/material/styles/styled';

export const ActionsBar = styled(Box)(() => ({
    position: 'absolute',
    bottom: '30px',
    right: '30px',
    margin: '0 auto',
    zIndex: 'modal',
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
}));

export const ActionBox = styled(IconButton)(({ theme }) => ({
    width: '43px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'white',
    },
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '50%',
}));

export const ActionBoxExpand = styled(ActionBox)(({ theme }) => ({
    borderRadius: '10px',
}));

export const ActionBoxZoomIn = styled(ActionBox)(() => ({
    borderRadius: '20px',
    borderBottom: '1px solid #D8D8D8',
    borderColor: '#D8D8D8',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
}));

export const ActionBoxZoomOut = styled(ActionBox)(() => ({
    borderRadius: '20px',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
}));
